import { z } from 'zod';

// src/interaction-capture/redaction.ts
var MAX_CAPTURE_REF_CHARS = 256;
var CaptureRouteRefSchema = /* @__PURE__ */ z.string().min(1).max(MAX_CAPTURE_REF_CHARS).refine((v) => !/[\s?#]/.test(v) && !v.includes("://"), {
  message: "route must be a normalized route id \u2014 no URLs, query strings, fragments, or whitespace"
});
var CaptureRefSchema = /* @__PURE__ */ z.string().min(1).max(MAX_CAPTURE_REF_CHARS).regex(/^[A-Za-z0-9._:/#@-]+$/, {
  message: "ref must be a structural token \u2014 no whitespace, markup, or free text"
});
var CAPTURE_HTTP_METHODS = [
  "GET",
  "POST",
  "PUT",
  "PATCH",
  "DELETE",
  "HEAD",
  "OPTIONS"
];
var CaptureHttpMethodSchema = /* @__PURE__ */ z.enum(CAPTURE_HTTP_METHODS);
var CAPTURE_ERROR_CLASSES = [
  "tool_error",
  "denied",
  "step_up_abandoned",
  "rate_limited",
  "not_found",
  "timeout",
  "validation",
  "unknown"
];
var CaptureErrorClassSchema = /* @__PURE__ */ z.enum(CAPTURE_ERROR_CLASSES);
function stripUrlToRoute(raw) {
  if (typeof raw !== "string" || raw.length === 0) return null;
  const withoutFragment = raw.split("#")[0] ?? "";
  let path = (withoutFragment.split("?")[0] ?? "").trim();
  const schemeIdx = path.indexOf("://");
  if (schemeIdx !== -1) {
    const afterAuthority = path.indexOf("/", schemeIdx + 3);
    path = afterAuthority === -1 ? "/" : path.slice(afterAuthority);
  }
  if (path.length === 0) return null;
  if (!path.startsWith("/")) path = `/${path}`;
  return path;
}
var EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
var JWT_RE = /\beyJ[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}\b/;
var LONG_DIGIT_RE = /\b\d{12,}\b/;
function looksLikePii(value) {
  return EMAIL_RE.test(value) || JWT_RE.test(value) || LONG_DIGIT_RE.test(value);
}
var PII_REDACTION_PLACEHOLDER = "[redacted]";
var EMAIL_RE_G = new RegExp(EMAIL_RE.source, "g");
var JWT_RE_G = new RegExp(JWT_RE.source, "g");
var LONG_DIGIT_RE_G = new RegExp(LONG_DIGIT_RE.source, "g");
var SSN_RE_G = /\b\d{3}-\d{2}-\d{4}\b/g;
var IBAN_RE_G = /\b[A-Z]{2}\d{2}[A-Z0-9]{11,30}\b/g;
var PHONE_RE_G = /(?:\+\d{1,3}[\s.-]?)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}\b|\+\d{1,3}(?:[\s.()-]*\d){6,14}/g;
function redactPiiInline(input) {
  return input.replace(JWT_RE_G, PII_REDACTION_PLACEHOLDER).replace(EMAIL_RE_G, PII_REDACTION_PLACEHOLDER).replace(IBAN_RE_G, PII_REDACTION_PLACEHOLDER).replace(SSN_RE_G, PII_REDACTION_PLACEHOLDER).replace(PHONE_RE_G, PII_REDACTION_PLACEHOLDER).replace(LONG_DIGIT_RE_G, PII_REDACTION_PLACEHOLDER);
}

export { CAPTURE_ERROR_CLASSES, CAPTURE_HTTP_METHODS, CaptureErrorClassSchema, CaptureHttpMethodSchema, CaptureRefSchema, CaptureRouteRefSchema, MAX_CAPTURE_REF_CHARS, PII_REDACTION_PLACEHOLDER, looksLikePii, redactPiiInline, stripUrlToRoute };
//# sourceMappingURL=chunk-AYGMX5PZ.js.map
//# sourceMappingURL=chunk-AYGMX5PZ.js.map